import { IconButton, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import { useState } from "react";
import AddMenuDropdown from "./addMenuDropdown";
import {NativeSelect} from '@mui/material';
import {InputLabel} from "@mui/material";
import {FormControl} from '@mui/material';
import storage from "../firebaseConfig2";
import {
    ref,
    uploadBytesResumable,
    getDownloadURL 
} from "firebase/storage";
import { database } from "../firebaseConfig2";
import {push,child,update} from "firebase/database";
import { collection, doc, setDoc } from "firebase/firestore"; 



function AddMenu(props) {
    const [submitType, setSubmitType] = useState("string");
    const [quote, setQuote] = useState("");
    const [file, setFile] = useState("");
    const [percent, setPercent] = useState(0);
    const [uploadedImageURL, setUploadedImageURL] = useState("");

    //submit either image or text
    const handleSubmit  = () => {
        if (submitType == "string"){
            let mydate = Date.now();
            const quotesRef= doc(database, "statuses", mydate.toString());
            setDoc(quotesRef, {
                message : quote,
                type:submitType,
                date: mydate
            });
            props.triggerUpdate(props.updater + 1);
        }
        else{
            let mydate = Date.now();
            const quotesRef= doc(database, "statuses", mydate.toString());
            setDoc(quotesRef, {
                quote : uploadedImageURL,
                type:submitType,
                date: mydate
                
            });     
        }
    }

     // Handle file upload event and update state
     function handleChange(event) {
        setFile(event.target.files[0]);
    }
    
    const handleUpload = () => {
        if (!file) {
            alert("Please upload an image first!");
        }
        console.log('uploading...');
        const storageRef = ref(storage, `/files/${file.name}`);
 
        // progress can be paused and resumed. It also exposes progress updates.
        // Receives the storage reference and the file to upload.
        const uploadTask = uploadBytesResumable(storageRef, file);
 
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const percent = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
 
                // update progress
                setPercent(percent);
            },
            (err) => console.log(err),
            () => {
                // download url
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    setUploadedImageURL(url);
                });
            }
        );
    };
    // ----------BEGIN HTML-------------
    return (
        
        <div className="addmenu-container">
            {/* --------- HEADER -------- */}
            <div className="addmenu-header">
                <h2 id="menutitle">New Entry</h2>
                <IconButton id="menucloser" onClick={() => props.setAddMenu(false)}>
                    <CloseIcon />
                </IconButton>
            </div>
            {/* --------- BEGIN FORM -------- */}
            <div className="addmenu-form">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                Entry type
                            </InputLabel>

                            {/* --------- DROPDOWN -------- */}
                            <NativeSelect
                                onChange={(e)=>setSubmitType((e.target.value))}
                                defaultValue={"string"}
                                inputProps={{
                                name: 'entry-type',
                                id: 'uncontrolled-native',
                                }}
                            >
                                <option value={"string"}>String</option>
                                <option value={"image"}>Image</option>
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setQuote(e.target.value)}
                                value = {quote.toString()}
                                required
                                fullWidth
                                id="input"
                                label="Message input"
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            <div className="character-counter">
                                {280 - quote.length}
                            </div>
                    </div>
                    {/* --------- IMAGE FIELD -------- */}
                    <div className="imgfield" style={{ display: (submitType == "image") ? 'block' : 'none' }}>
                        <input type="file" onChange={handleChange} accept="" />
                        <button onClick={() => handleUpload(file,percent)}>Upload to Firebase</button>
                        <p>{percent} "% done"</p>
                    </div>
                    
                       
                    </Grid>
                    </Grid>

                {/* --------- SUBMIT -------- */}
                <Button
                onClick={()=>handleSubmit()}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                >
                Submit
                </Button>
                <Grid container justifyContent="flex-end">
                </Grid>
            </div>
        </div>
       
      );
}

export default AddMenu;